export default "__VITE_ASSET__Baurcf_N__"